export default "/images/vendor/flag-icon-css/flags/1x1/ro.svg?6d757067ccc276327b1b444f1f3789cc";